import React, { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setBreakpoint } from "./reduxToolKit/features/slice";

import WaiverDownload from "./pages/download/WaiverDownload";
import WaiverForm from "./pages/signWaiver/waiverForm";
import Login from "./pages/loginPage/login";
import AutoToPage from "./pages/authPage/authToPage";
import MainBoard from "./pages/dashboard/mainBoard";
import WeeklyCalendar from "./Components/WeeklyCalendar";
import InvitationCardDownloader from "./pages/download/invitationcarddownloader";
function App() {
  // const location = useLocation();
  // const navigate = useNavigate();
  // const dispatch = useDispatch();

  // useEffect(() => {
  //   if (location.pathname === "/") {
  //     navigate("/waiver");
  //   }
  // }, [location.pathname]);

  // useEffect(() => {
  //   const handleResize = () => {
  //     const screenWidth = window.innerWidth;
  //     let currentBreakpoint = "desktop"; // default to xl

  //     if (screenWidth < 1200 && screenWidth > 620) {
  //       currentBreakpoint = "tablet";
  //     } else if (screenWidth < 620) {
  //       currentBreakpoint = "mobile";
  //     }
  //     dispatch(setBreakpoint(currentBreakpoint));
  //   };

  //   handleResize();
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, [window.innerWidth]);

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        // boxSizing: "content-box",
        top: "0",
        left: "0",
        overflowX: "hidden",
        // backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <Routes>
        <Route path="/waiver" element={<WaiverForm />} />
        <Route path="/authorization" element={<AutoToPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/adminDashboard" element={<MainBoard />}></Route>
        <Route path="/weeklyCalendar" element={<WeeklyCalendar />} />
        <Route
          path="/invitationcarddownload"
          element={<InvitationCardDownloader />}
        />
      </Routes>
    </div>
  );
}

export default App;
